import apiClient from './apiClient';

// ============================================================
// Types -- matching backend Go models (g203/models/g203.go)
// ============================================================

export interface ARReplyItem {
  rowNum: number;
  customerId: string;
  deliveryNo: string;
  receivableAmt: number;
  collectedAmt: number;
  outstandingAmt: number;
  currency: string;
  paymentTerms: string;
  deliveryDate: string | null;
  deliveryMethod: string;
  agingCategory: number;
  agingText: string;
  replyCode: string;
  expectedRecoveryDate: string | null;
  expectedWriteOffDate: string | null;
  otherFactors: string;
  dueDate: string | null;
  isOverdue: boolean;
  isAutoSet: boolean;
  hasPaymentDetails: boolean;
}

export interface SaveItem {
  customerId: string;
  deliveryNo: string;
  replyCode: string;
  expectedRecoveryDate?: string | null;
  expectedWriteOffDate?: string | null;
  otherFactors: string;
}

export interface PaymentDetail {
  rowNum: number;
  customerId: string;
  deliveryNo: string;
  writeOffDocNo: string;
  writeOffAmt: number;
  writeOffDate: string | null;
  docTypeCode: string;
  docTypeText: string;
}

export interface ReplyCodeOption {
  code: string;
  label: string;
}

export interface QueryResponse {
  items: ARReplyItem[];
  totalCount: number;
}

export interface SaveResponse {
  updatedCount: number;
  errors?: string[];
}

// ============================================================
// API methods
// ============================================================

export const g203Api = {
  query: (customerId: string, salesPersonId: string) =>
    apiClient.post<QueryResponse>('/api/pwg203/query', { customerId, salesPersonId }),

  save: (items: SaveItem[]) =>
    apiClient.put<SaveResponse>('/api/pwg203/save', { items }),

  getPaymentDetails: (customerId: string, deliveryNo: string) =>
    apiClient.get<PaymentDetail[]>('/api/pwg203/payment-details', {
      params: { customerId, deliveryNo },
    }),

  getReplyCodeOptions: () =>
    apiClient.get<ReplyCodeOption[]>('/api/pwg203/reply-codes'),
};
